import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {white} from '/theme/color/on.color';
import {denim} from '/theme/color/on.color';
import {alto} from '/theme/color/secondary.color';

export const styles = StyleSheet.create({
  container: {
    backgroundColor: white,
    flex: 1,
  },
  headerText: {
    fontSize: 20,
    fontWeight: '700',
    flexShrink: 1,
  },
  itemContainer: {
    paddingVertical: indent * 1.1,
    paddingHorizontal: indent * 0.9,
    borderTopWidth: 1,
    borderColor: alto,
    flexDirection: 'row',
    alignItems: 'flex-start',
  },
  icon: {
    marginRight: indent * 1.15,
    fontSize: 18,
  },
  iconSelected: {
    color: denim,
  },
  contentContainer: {
    paddingBottom: 40,
  },
});
